import React from 'react';
import { MarkdownRenderer } from '../Common/MarkdownRenderer';
import styles from '../Editor/MarkdownEditor.module.css';

interface DocumentPreviewProps {
  content: string;
}

export const DocumentPreview: React.FC<DocumentPreviewProps> = ({ content }) => {
  return (
    <div className={styles.previewPanel}>
      <div className={styles.panelHeader}>
        Live Preview
        <span style={{ marginLeft: 'auto', fontSize: '11px', opacity: 0.7, textTransform: 'none' }}>
          See your rendered content
        </span>
      </div>
      <div className={styles.previewContent}>
        {content ? (
          <MarkdownRenderer content={content} />
        ) : (
          <div style={{ 
            color: 'var(--text-muted)', 
            textAlign: 'center', 
            padding: '40px 20px',
            fontSize: '14px',
            fontStyle: 'italic'
          }}>
            Your markdown preview will appear here as you type...
          </div>
        )}
      </div>
    </div>
  );
};
